import React from 'react';

export function IconDollar() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#1A1A1A"/>
        <path d="M24.3 22.9C22.03 22.31 21.3 21.7 21.3 20.75C21.3 19.66 22.31 18.9 24 18.9C25.42 18.9 26.13 19.44 26.39 20.3C26.51 20.7 26.84 21 27.26 21H27.56C28.22 21 28.69 20.35 28.46 19.73C28.04 18.55 27.06 17.57 25.5 17.19V16.5C25.5 15.67 24.83 15 24 15C23.17 15 22.5 15.67 22.5 16.5V17.16C20.56 17.58 19 18.84 19 20.77C19 23.08 20.91 24.23 23.7 24.9C26.2 25.5 26.7 26.38 26.7 27.31C26.7 28 26.21 29.1 24 29.1C22.35 29.1 21.5 28.51 21.17 27.67C21.02 27.28 20.68 27 20.27 27H19.99C19.32 27 18.85 27.68 19.1 28.3C19.67 29.69 21 30.51 22.5 30.83V31.5C22.5 32.33 23.17 33 24 33C24.83 33 25.5 32.33 25.5 31.5V30.85C27.45 30.48 29 29.35 29 27.3C29 24.46 26.57 23.49 24.3 22.9Z" fill="white"/>
        </svg>

    );
}

export function IconActiveListing() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#1A1A1A"/>
        <g clipPath="url(#clip0_2685_8192)">
        <path d="M25.25 13.5H31.5H32.5C33.3284 13.5 34 14.1716 34 15V17.25V24.5C34 25.3284 33.3284 26 32.5 26H25.25V31V34.75C25.25 35.4404 24.6904 36 24 36C23.3096 36 22.75 35.4404 22.75 34.75V31V26H15.5C14.6716 26 14 25.3284 14 24.5V21V15C14 14.1716 14.6716 13.5 15.5 13.5H22.75V12.25C22.75 11.5596 23.3096 11 24 11C24.6904 11 25.25 11.5596 25.25 12.25V13.5Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_2685_8192">
        <rect width="24" height="24" fill="white" transform="translate(12 12)"/>
        </clipPath>
        </defs>
        </svg>
    );
}

export function IconNewListing() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#1A1A1A"/>
        <path d="M31 21L32.25 18.25L35 17L32.25 15.75L31 13L29.75 15.75L27 17L29.75 18.25L31 21Z" fill="white"/>
        <path d="M31 27L29.75 29.75L27 31L29.75 32.25L31 35L32.25 32.25L35 31L32.25 29.75L31 27Z" fill="white"/>
        <path d="M23.5 21.5L21 16L18.5 21.5L13 24L18.5 26.5L21 32L23.5 26.5L29 24L23.5 21.5ZM21.99 24.99L21 27.17L20.01 24.99L17.83 24L20.01 23.01L21 20.83L21.99 23.01L24.17 24L21.99 24.99Z" fill="white"/>
        </svg>
    );
}

export function IconCalendar() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#1A1A1A"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M31 15H32C33.1 15 34 15.9 34 17V33C34 34.1 33.1 35 32 35H16C14.9 35 14 34.1 14 33V17C14 15.9 14.9 15 16 15H17V14C17 13.45 17.45 13 18 13C18.55 13 19 13.45 19 14V15H29V14C29 13.45 29.45 13 30 13C30.55 13 31 13.45 31 14V15ZM17 33H31C31.55 33 32 32.55 32 32V20H16V32C16 32.55 16.45 33 17 33Z" fill="white"/>
        </svg>
    );
}

